import { render, staticRenderFns } from "./InfoBloc.vue?vue&type=template&id=67913456"
import script from "./InfoBloc.vue?vue&type=script&lang=js"
export * from "./InfoBloc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports